import React, { useMemo } from "react";
import Dropdown from "components/Elements/Dropdown";
import { TimezoneOptions } from "constants/reportSubscriptions";
import FieldLabel from "./FieldLabel";

const TimezoneField = ({ value, onChange, label = "Timezone", required = false }) => {
	const selected = useMemo(
		() => TimezoneOptions.find((o) => o.value === value) || {},
		[value]
	);

	return (
		<div>
			<FieldLabel required={required}>{label}</FieldLabel>
			<Dropdown
				options={TimezoneOptions}
				selectedValue={selected}
				onChange={(opt) => onChange(opt.value)}
				placeholder="Select a timezone"
				width="100%"
			/>
		</div>
	);
};

export default TimezoneField;
